import React, { useEffect, useState } from "react";
import Sidebar from "../../../../component/b2c/sidebar/sidebar";
import NavBar from "../../../../component/b2c/navBar/navBar";
import { useMyContext } from "../../../../context/MyContext";
import { Base_Url, userCodList, fetchUser, CodPlanChange, paymentProcess } from "../../../../config/config";
import { toast } from 'react-toastify';
// import Select from "react-dropdown-select";
import Select from 'react-select'
import axios from "axios";
import { FaRupeeSign } from "react-icons/fa";
import ViewRemmitance from "../../../../component/b2c/models/viewRemmitance";
import { FcProcess } from "react-icons/fc";
import '../../../../css/custom-scrollbar.css'
import {
    Upload,
    Eye,
    Download,
    Calendar,
    TrendingUp,
    CreditCard,
    Truck,
    Target,
    Timer, 
    Building
} from 'lucide-react';
import { IoSpeedometer } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';


const RemittanceList = () => {
    const [remittances, setRemittances] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [data, setData] = useState([]);
    const { isDarkMode, isToggleSidebar } = useMyContext()
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [Id, setId] = useState('')
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);

    const cus_id = localStorage.getItem("cus_id");
    const token = localStorage.getItem("token");

    // const handleSelectChangeId = (selectedOption) => {
    //     setSelectedCustomerId(selectedOption[0].value);
    // };


    // const handleSelectChangeId = (selectedOptions) => {
    //     if (selectedOptions && selectedOptions.length > 0) {
    //         setSelectedCustomerId(selectedOptions.map(opt => opt.value));
    //     } else {
    //         setSelectedCustomerId([]);
    //     }
    // };


    const handleSelectChangeId = (selectedOptions) => {
        if (Array.isArray(selectedOptions)) {
            setSelectedCustomerId(selectedOptions.length > 0 ? selectedOptions.map(opt => opt.value) : []);
        } else if (selectedOptions) {
            // In case there's only a single selected option (non-array case)
            setSelectedCustomerId([selectedOptions.value]);
        } else {
            setSelectedCustomerId([]);
        }
    };


    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    useEffect(() => {
        fetchRemittanceList();
        fetchCustomers();
    }, []);

    const handleSelectChange = (selected) => {
        if (selected.length > 0) {
            const selectedItem = selected[0];
            setId(selectedItem.value);
        }
    };

    const fetchRemittanceList = async () => {
        try {
            const headers = {
                "Content-Type": "application/json",
                cus_id,
                token,
            };


            const response = await fetch(Base_Url + userCodList, {
                method: "GET",
                headers,
            });

            const result = await response.json();

            if (result.status === "SUCCESS") {
                setRemittances(result.data || []);
            }
            else {
                toast.error(result.message);
            }
        } catch (error) {
            console.error("Failed to fetch remittance data", error);
        }
    };

    const fetchCustomers = async () => {
        const url = Base_Url + fetchUser;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    token: token,
                    cus_id: cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.status === "success") {
                // const transformedData = data.data.map(user => ({
                //     value: user.id,
                //     label: `${user.name} (${user.id})`, // Show id and name
                // }));
                const transformedData = data.data.map(user => {
                    const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
                    return {
                        value: user.id,
                        label: `${capitalizedName} (${user.id})`,
                    };
                });
                setCustomers(transformedData);

            } else {
                toast.error(`Error: ${data.message} (Code: ${data.code})`);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    }

    const payoutCards = [
        {
            id: 'D+1',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 1 Day',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '2% of COD amount',
            note: '(Inclusive GST)',
            icon: <Truck className="w-8 h-8" />,
            color: 'from-blue-500 to-blue-600',
            bgColor: 'bg-gradient-to-br from-blue-50 to-blue-100',
            iconColor: 'text-blue-600'
        },
        {
            id: 'D+2',
            frequency: '20 Payouts/Months',
            title: 'Delivered + 2 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Target className="w-8 h-8" />,
            color: 'from-orange-500 to-red-500',
            bgColor: 'bg-gradient-to-br from-orange-50 to-red-100',
            iconColor: 'text-orange-600'
        },
        {
            id: 'D+3',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 3 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '1% of COD amount',
            note: '(Inclusive GST)',
            icon: <Timer className="w-8 h-8" />,
            color: 'from-green-500 to-emerald-600',
            bgColor: 'bg-gradient-to-br from-green-50 to-emerald-100',
            iconColor: 'text-green-600'
        },
        {
            id: 'D+4',
            frequency: '8 Payouts/Months',
            title: 'Delivered + 4 Days',
            subtitle: 'At Minimal Transaction Charge',
            percentage: '0.75% of COD amount',
            note: '(Inclusive GST)',
            icon: <Building className="w-8 h-8" />,
            color: 'from-purple-500 to-indigo-600',
            bgColor: 'bg-gradient-to-br from-purple-50 to-indigo-100',
            iconColor: 'text-purple-600'
        }
    ];

    const navigate = useNavigate();
    const handleActivatePayout = async (cardId) => {
        if (!selectedCustomerId) {
            toast.error("Please select a customer ID.");
            return;
        }
        try {
            const apiUrl = Base_Url + CodPlanChange;
            const headers = {
                cus_id: cus_id,
                token: token,
                "Content-Type": "application/json",
            };

            const payload = {
                retailer_id: selectedCustomerId,
                plan: cardId,
                status: "Active",
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === "SUCCESS") {
                toast.success(response.data.message);
                navigate('/dashboard');
            } else {
                toast.error(response.data?.message || "Activation failed.");
                console.error("Failed to activate payout:", response.data);
            }
        } catch (error) {
            toast.error("Something went wrong.");
            console.error("API error:", error);
        }
    };

    // const handleDownload = (item) => {
    //     // Example: Download receipt or statement
    //     const downloadUrl = `/api/remittance/${item.settle_id}/download`;
    //     window.open(downloadUrl, '_blank');
    // };


    const handleView = (item) => {
        setData(item)
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleProcess = async (item) => {

        try {
            const apiUrl = Base_Url + paymentProcess;
            const headers = {
                cus_id: cus_id,
                token: token,
                "Content-Type": "application/json",
            };

            const payload = {
                retailer_id: item.retailer_id,
                settle_id: item.settle_id,
                status: "Process",
                tnx_id : item.tnx_id ,
                amount: item.remaining_amount,
            };

            const response = await axios.post(apiUrl, payload, { headers });

            if (response.data?.status === "SUCCESS") {
                toast.success(response.data.message);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Something went wrong.");
        }
    };

    // const handleUpload = (item) => {
    // };

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} `}>
                <div className="z-10">
                    <NavBar />
                </div>

                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            }>
                            <Sidebar />
                        </div>
                    )}
                    <div className={` bg-gray-100 overflow-x-hidden ml-4  mb-6 mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4  custom-scrollbar ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
                        <div className="mb-8 text-center">
                            <div className="inline-flex items-center gap-2 mb-3">
                                <div className={`p-2 rounded-lg ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-100'}`}>
                                    <FaRupeeSign className={`w-6 h-6 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                                </div>
                                <h1 className={`text-2xl font-bold bg-gradient-to-r ${isDarkMode ? 'from-white to-purple-200' : 'from-gray-900 to-purple-600'} bg-clip-text text-transparent`}>
                                    Remittance Dashboard
                                </h1>
                            </div>
                            <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} max-w-2xl mx-auto`}>
                                Monitor your payment settlements, track remittance history, and manage upcoming payouts with real-time insights
                            </p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            {payoutCards.map((card, index) => (
                                <div
                                    key={card.id}
                                    className={`relative overflow-hidden rounded-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-[1.02] ${isDarkMode ? 'bg-white/10 backdrop-blur-lg border border-white/20' : 'bg-white backdrop-blur-lg border border-gray/20'} shadow-md hover:shadow-lg`}
                                >
                                    {/* Frequency Badge */}
                                    {/* <div className="absolute top-3 left-3 right-3">
                                                                       <div className={`inline-block px-2 py-1 rounded-full text-xs font-bold text-white bg-gradient-to-r ${card.color}`}>
                                                                           {card.frequency}
                                                                       </div>
                                                                   </div> */}

                                    {/* Card Content */}
                                    <div className="pt-10 pb-4 px-4 text-center">
                                        {/* Icon */}
                                        <div className={`inline-flex items-center justify-center w-10 h-10 rounded-full ${card.bgColor} mb-3 mx-auto`}>
                                            <div className={card.iconColor}>
                                                {React.cloneElement(card.icon, { className: "w-5 h-5" })}
                                            </div>
                                        </div>

                                        {/* Title */}
                                        <h3 className={`text-sm font-bold mb-1 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                                            {card.title}
                                        </h3>

                                        {/* Subtitle */}
                                        <p className={`text-xs mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                            {card.subtitle}
                                        </p>

                                        {/* Percentage */}
                                        <div className={`text-lg font-bold mb-1 bg-gradient-to-r ${card.color} bg-clip-text text-transparent`}>
                                            {card.percentage}
                                        </div>

                                        {/* Note */}
                                        <p className={`text-xs mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                            {card.note}
                                        </p>

                                        {/* Activate Button */}
                                        <button
                                            onClick={() => handleActivatePayout(card.id)}
                                            disabled={!selectedCustomerId}
                                            className={`w-full py-2 px-3 rounded-lg font-bold text-white text-xs transition-all duration-300 transform hover:scale-105 active:scale-95 bg-gradient-to-r from-green-500 to-green-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500/30 ${!selectedCustomerId ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                        >
                                            Activate
                                        </button>

                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-4 ml-2 mr-2">
                            <label htmlFor="Id" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                                Select Id
                            </label>
                            <Select
                                // isMulti
                                options={customers}
                                //  isSearchable={false}
                                onChange={handleSelectChangeId}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        padding: "0.5rem",
                                        borderRadius: "0.375rem",
                                        width: "100%",
                                        backgroundColor: isDarkMode ? "rgba(1, 14, 78, 0.96)" : "",
                                        color: isDarkMode ? "white" : "rgba(1, 14, 78, 0.96)",
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: isDarkMode ? "white" : "rgba(1, 14, 78, 0.96)",
                                    }),
                                }}
                            />
                        </div>
                        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                            <div className="flex flex-col gap-3">
                                <div
                                    className={`flex items-center gap-3 p-2.5 rounded-lg w-48
          ${isDarkMode ? 'bg-blue-500/20' : 'bg-blue-50'}
          hover:scale-105 transition-transform cursor-pointer`}
                                >
                                    <Calendar className={`w-5 h-5 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
                                    <div className="flex flex-col leading-tight">
                                        <h3 className={`text-xs font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                            Schedule
                                        </h3>
                                        <p className={`text-[10px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                            Auto payout
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className={`flex items-center gap-3 p-2.5 rounded-lg w-48
          ${isDarkMode ? 'bg-green-500/20' : 'bg-green-50'}
          hover:scale-105 transition-transform cursor-pointer`}
                                >
                                    <TrendingUp className={`w-5 h-5 ${isDarkMode ? 'text-green-400' : 'text-green-600'}`} />
                                    <div className="flex flex-col leading-tight">
                                        <h3 className={`text-xs font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                            Analytics
                                        </h3>
                                        <p className={`text-[10px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                            Insights
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className={`flex items-center gap-3 p-2.5 rounded-lg w-48
          ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-50'}
          hover:scale-105 transition-transform cursor-pointer`}
                                >
                                    <CreditCard className={`w-5 h-5 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                                    <div className="flex flex-col leading-tight">
                                        <h3 className={`text-xs font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                            Payment
                                        </h3>
                                        <p className={`text-[10px] ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                            Accounts
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`rounded-xl p-4 shadow-md w-full
      ${isDarkMode ? 'bg-white/10 border border-white/20 text-white' : 'bg-white border border-gray-200 text-gray-800'}
      `}
                            >
                                <h2 className="text-sm font-semibold mb-3">Recent Transactions</h2>

                                <table className="w-full text-xs">
                                    <thead className={`${isDarkMode ? 'bg-white/10' : 'bg-gray-100'} text-left`}>
                                        <tr>
                                            <th className="py-2 px-2">ID</th>
                                            <th className="py-2 px-2">Amount</th>
                                            <th className="py-2 px-2">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className={`${isDarkMode ? 'hover:bg-white/5' : 'hover:bg-gray-50'} transition`}>
                                            <td className="py-2 px-2">#1001</td>
                                            <td className="py-2 px-2">₹2500</td>
                                            <td className="py-2 px-2 text-green-500">Success</td>
                                        </tr>
                                        <tr className={`${isDarkMode ? 'hover:bg-white/5' : 'hover:bg-gray-50'} transition`}>
                                            <td className="py-2 px-2">#1002</td>
                                            <td className="py-2 px-2">₹780</td>
                                            <td className="py-2 px-2 text-yellow-500">Pending</td>
                                        </tr>
                                        <tr className={`${isDarkMode ? 'hover:bg-white/5' : 'hover:bg-gray-50'} transition`}>
                                            <td className="py-2 px-2">#1003</td>
                                            <td className="py-2 px-2">₹1200</td>
                                            <td className="py-2 px-2 text-red-500">Failed</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> */}
                        <div className="overflow-x-auto mt-4 rounded-xl">
                            <table className="min-w-full border border-gray-400 table-fixed overflow-y-auto">
                                <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                                    <tr>
                                        <th className="p-2 text-left font-medium w-1/5">Settled ID</th>
                                        <th className="p-2 text-left font-medium w-1/5">Retailer ID</th>
                                        <th className="p-2 text-left font-medium w-1/5">Status</th>
                                        <th className="p-2 text-left font-medium w-1/5">COD Amount</th>
                                        <th className="p-2 text-left font-medium w-1/5">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                                    {remittances.length === 0 ? (
                                        <tr>
                                            <td
                                                colSpan={5}
                                                className="p-4 text-center text-sm text-gray-500 dark:text-gray-300"
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    ) : (
                                        remittances.map((item, index) => (
                                            <tr
                                                key={item.id}
                                                className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                                                    ? "bg-white dark:bg-darkmodeColor"
                                                    : "bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]"
                                                    }`}
                                            >
                                                <td className="p-2 text-xs text-gray-700 dark:text-gray-300 w-1/5">
                                                    {item.settle_id}
                                                 </td>
                                                <td className="p-2 text-xs font-medium text-gray-700 dark:text-gray-300 w-1/5">
                                                    {item.retailer_id}
                                                </td>
                                                <td className="p-2 text-xs text-gray-700 dark:text-gray-300 w-1/5">
                                                    {item.status}
                                                </td>
                                                <td className="p-2 text-xs font-semibold text-gray-900 dark:text-gray-100 w-1/5">
                                                    ₹{item.remaining_amount}
                                                </td>
                                                <td className="p-2 w-1/5">
                                                    <div className="flex space-x-2">
                                                        {/* <button
                                                            onClick={() => handleDownload(item)}
                                                            className="p-1 rounded-md bg-green-100 hover:bg-green-200 dark:bg-green-800 dark:hover:bg-green-700 text-green-600 dark:text-green-300 transition-colors duration-150"
                                                            title="Download"
                                                        >
                                                            <Download size={14} />
                                                        </button> */}
                                                        {/* <button
                                                            onClick={() => handleUpload(item)}
                                                            className="p-1 rounded-md bg-blue-100 hover:bg-blue-200 dark:bg-blue-800 dark:hover:bg-blue-700 text-blue-600 dark:text-blue-300 transition-colors duration-150"
                                                            title="Upload"
                                                        >
                                                            <Upload size={14} />
                                                        </button> */}
                                                        <button
                                                            onClick={() => handleView(item)}
                                                            className="p-1 rounded-md bg-purple-100 hover:bg-purple-200 dark:bg-purple-800 dark:hover:bg-purple-700 text-purple-600 dark:text-purple-300 transition-colors duration-150"
                                                            title="View"
                                                        >
                                                            <Eye size={14} />
                                                        </button>
                                                        <button
                                                            onClick={() => handleProcess(item)}
                                                            className="p-1 rounded-md bg-orange-100 hover:bg-orange-200 dark:bg-orange-800 dark:hover:bg-orange-700 text-orange-600 dark:text-orange-300 transition-colors duration-150"
                                                            title="Process"
                                                        >
                                                            <FcProcess size={14} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>


                            {/* <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                                <span className="text-xs text-gray-700 font-bold dark:text-gray-300">{`Total Warehouses: ${totalOrders}`}</span>
                                <select
                                    id="limit"
                                    value={limit}
                                    onChange={handleLimitChange}
                                    className={`border rounded p-1 ml-[480px] text-xs bg-white dark:bg-darkmodeColor dark:text-gray-200 ${totalOrders < 10 ? 'cursor-not-allowed opacity-400' : ''}`}
                                    disabled={totalOrders < 10}
                                >
                                    {totalOrders === 0 ? (
                                        <option value={0}>0</option>
                                    ) : (
                                        <>
                                            <option value={10}>10</option>
                                            <option value={15}>15</option>
                                            <option value={20}>20</option>
                                            <option value={30}>30</option>
                                            <option value={totalOrders}>All</option>
                                        </>
                                    )}
                                </select>

                                <Pagination
                                    count={Math.ceil(totalOrders / limit)}
                                    page={currentPage}
                                    onChange={handlePaginationChange}
                                    variant="outlined"
                                    shape="rounded"
                                    className="pagination"
                                    size="small"
                                    renderItem={(item) => (
                                        <PaginationItem
                                            {...item}
                                            className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                                        />
                                    )}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
                <ViewRemmitance isopen={isPopupOpen} onClose={handleClose} data={data} />
            </div>
        </>
    );
};

export default RemittanceList;